import React from 'react';

import st from './SideNavLayout.module.sass';

interface SideNavLayoutProps {
  /** Боковая навигация разделов (панель Bar). */
  nav: React.ReactNode;
  /** Контент выбранного раздела. */
  main: React.ReactNode;
  /** Опциональная правая колонка (геопозиция, легенда и т.п.). */
  info?: React.ReactNode;
}

// Общая раскладка страниц настроек: боковая навигация + контент раздела + опц. Info-колонка.
function SideNavLayout({
  nav,
  main,
  info = undefined,
}: SideNavLayoutProps): React.JSX.Element {
  return (
    <div className={st.Root}>
      <div className={st.Nav}>{nav}</div>

      <div className={st.Main}>{main}</div>

      {!!info && <div className={st.Info}>{info}</div>}
    </div>
  );
}

export { SideNavLayout };
